export const openUploadWidget = (options, callback) => {
    window.cloudinary.openUploadWidget(options, callback);
  };
  